import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  activeTab: 'active',

  modal: {
    open: null,
    data: {},
  },
};

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setActiveTab: (state, {payload}) => ({
      ...state,
      activeTab: payload,
    }),
    setModal: (state, {payload}) => ({
      ...state,
      modal: {
        ...state.modal,
        ...payload,
      },
    }),
    resetModal: state => ({
      ...state,
      modal: initialState.modal,
    }),
  },
});

export const applicationState = state => state.application;

export const {setActiveTab, setModal, resetModal} = applicationSlice.actions;

export default applicationSlice.reducer;
